"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECTION_BLOCK_SELECTOR = void 0;
exports.SECTION_BLOCK_SELECTOR = "section[data-qwilr-component=\"block\"]";
